import { spacing } from '@retailer-platform/shared-components'
import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { type Moment } from 'moment'
import { ReportsNormalizedReportsListDateRangePresetSelect } from 'domains/reports/components/normalized-reports-list/components/date-range-preset-select/ReportsNormalizedReportsListDateRangePresetSelect'
import { DateRangePreset } from 'domains/reports/components/normalized-reports-list/components/date-range-preset-select/ReportsNormalizedReportsListDateRangePresetSelect'
import { ReportsNormalizedReportsListCustomDateRange } from 'domains/reports/components/normalized-reports-list/components/custom-date-range/ReportsNormalizedReportsListCustomDateRange'
import { type ReportTypeEnum } from 'domains/reports/api'
import { ReportsNormalizedReportsListReportTypeSelect } from 'domains/reports/components/normalized-reports-list/components/report-type-select/ReportsNormalizedReportsListReportTypeSelect'
import { ReportsNormalizedReportsListMergeButtonAndModal } from 'domains/reports/components/normalized-reports-list/components/merge-button-and-modal/ReportsNormalizedReportsListMergeButtonAndModal'

interface DateRange {
  startDate: Moment
  endDate: Moment
}

interface ReportsNormalizedReportsListFiltersProps {
  reportCount: number
  partnerId: string
  retailerId: string
  dateRangePreset: DateRangePreset
  setDateRangePreset: (r: DateRangePreset) => void
  dateRange: DateRange
  setDateRange: (d: DateRange) => void
  reportType: ReportTypeEnum
  setReportType: (t: ReportTypeEnum) => void
}

const StyledContainer = styled.div({
  display: 'flex',
  padding: spacing.X24,
  alignItems: 'center',
  height: 100,
  justifyContent: 'space-between',

  '& > .filter-container': {
    display: 'flex',

    '& > .filter-item': {
      width: 200,
      marginRight: spacing.X24,

      '&:last-child': {
        marginRight: 0,
      },
    },
  },
})

export const ReportsNormalizedReportsListFilters: FunctionComponent<
  ReportsNormalizedReportsListFiltersProps
> = ({
  reportCount,
  partnerId,
  retailerId,
  dateRangePreset,
  setDateRangePreset,
  dateRange,
  setDateRange,
  reportType,
  setReportType,
}) => (
  <StyledContainer>
    <div className="filter-container">
      <div className="filter-item">
        <ReportsNormalizedReportsListReportTypeSelect
          selectedReportType={reportType}
          onChange={setReportType}
        />
      </div>

      <div className="filter-item">
        <ReportsNormalizedReportsListDateRangePresetSelect
          selectedDateRange={dateRangePreset}
          onChange={setDateRangePreset}
        />
      </div>

      {dateRangePreset === DateRangePreset.Custom && (
        <div className="filter-item">
          <ReportsNormalizedReportsListCustomDateRange
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
            onDatesChange={setDateRange}
          />
        </div>
      )}
    </div>

    <ReportsNormalizedReportsListMergeButtonAndModal
      reportCount={reportCount}
      partnerId={partnerId}
      retailerId={retailerId}
      reportType={reportType}
      dateRangePreset={dateRangePreset}
      dateRange={dateRange}
    />
  </StyledContainer>
)
